// extracted by mini-css-extract-plugin
export default {"tag":"HXJxqbiqOYhGWDcv6TC1","button":"qi9Ajqb5eHDn0krdqnC7","popover":"_ePHe54uaHvaOkocxhy7"};